// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const charcoalPile = defineModel({
  id: "charcoal-pile",
  batchId: "future",
  name: "Charcoal pile",
  tags: ["scenery","charcoal","pile","low-poly","age-of-mcp","future"],
  summary: "A heap of charcoal — the hot, clean fuel for smelting and glass.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.36, 0.4, 0.04, 11), color: "#34352f", position: [0, 0.02, 0] },
      { geometry: new THREE.ConeGeometry(0.32, 0.34, 8), color: "#1d1e20", position: [0, 0.21, 0] },
      { geometry: new THREE.TetrahedronGeometry(0.07, 0), color: "#2a2b2e", position: [0.12, 0.12, 0.08], rotation: [0.4, 0.6, 0.2] },
      { geometry: new THREE.TetrahedronGeometry(0.06, 0), color: "#1d1e20", position: [-0.14, 0.1, -0.04], rotation: [0.2, 1, 0.3] },
      { geometry: new THREE.TetrahedronGeometry(0.05, 0), color: "#2a2b2e", position: [0.02, 0.2, -0.1], rotation: [0.5, 0.3, 0.1] },
      { geometry: new THREE.TetrahedronGeometry(0.05, 0), color: "#1d1e20", position: [0.24, 0.04, -0.16], rotation: [0.3, 0.4, 0.2] },
    ],
  animations: [],
});
